export default __webpack_public_path__ + "static/media/amc_Partners_logo.176bf5fa.svg";